import BreakpointsEnum from "./enums/breakpointsEnum";

$(function () {
    let App = window.App;
    App.brands = {};

    let perPage = parseInt($('.brands-page .brands-list').data('per-page'));
    let $showMoreBtn = $('.brands-page .pagination-container button');

    const setActiveTab = function ($self) {
        $self.closest('.tabs').find('li.active').removeClass('active');
        $self.closest('li').addClass('active');
        $('.brands-page .brands-list .brand:not(.hidden)').addClass('hidden');
    }

    const onApplyFilter = function ($self) {
        if (parseInt($self.closest('li').data('items-count')) > perPage) {
            $showMoreBtn.removeClass('hidden');
        } else {
            $showMoreBtn.addClass('hidden');
        }

        let letter = $self.data('letter');

        if (letter !== undefined) {
            $('.brands-page .brands-list .brand[data-letter=' + letter + ']:lt(' + perPage + ')').removeClass('hidden');
        } else {
            $('.brands-page .brands-list .brand:lt(' + perPage + ')').removeClass('hidden');
        }
    }

    App.brands.onShowMoreClick = function () {
        perPage *= 2;
        onApplyFilter($('.brands-page .tabs li.active button'));
    }

    App.brands.onTabClick = function ($this) {
        if ($this.hasClass('active')) {
            return false;
        }

        perPage = parseInt($('.brands-page .brands-list').data('per-page'));
        setActiveTab($this);
        onApplyFilter($this);
    }

    $(window).on('load scroll resize orientationchange', function () {
        if (window.App.getBreakpoint() === BreakpointsEnum.mobile && !$('.brands-page .tabs li.all').hasClass('active')) {
            $('.brands-page .tabs li.all button').click();
        }
    });
});